module.exports = __webpack_public_path__ + "static/img/gc_tb7_2.1224a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/hardWare/gc/gc_tb7_2.png
// module id = S+7w
// module chunks = 0